var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.422.527C10.716.673 9.46 1.648 8.929 3.238c-.252.755-.258.82-.281 2.887l-.02 1.873-1.392.009-1.391.009v3.534h2.8v8.961l1.706-.009 1.707-.009.008-4.472.009-4.471h2.678l.202-1.706c.111-.939.202-1.734.201-1.768-.001-.057-.098-.061-1.541-.061h-1.54l.001-1.444c0-1.545.018-1.755.18-2.078.111-.222.361-.443.605-.535.309-.115.608-.141 1.655-.142l.954-.001V.64l-.219-.022c-.866-.087-2.327-.134-2.829-.091",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeFacebook);
export default __webpack_public_path__ + "static/media/icone-facebook.89d74c3c8d4af4b0431b591ef5184274.svg";
export { ForwardRef as ReactComponent };